<script>
  export let bg_pc = '/images/sub_brand.png';
  export let bg_mo = '/images/sub_brand_m.png';
  export let title = '';
  export let dsc   = '';
</script>

{#if title}
<div class="layout__sub-header header header_sub" style="{'--bg-pc:url(\'' + bg_pc + '\'); --bg-mo: url(\'' + bg_mo + '\');'}">
    <h2 class="header__heading heading heading_level_2">{title}</h2>
    {#if dsc}<span class="header__text text text_large">{@html dsc}</span>{/if}
</div>
{/if}

<style>
  .layout__sub-header:after {
    background-image: var(--bg-pc, url('/images/sub.png'));
    background-position: center center;
    background-size: cover;
    z-index: -2;
  }

  @media screen and (max-width: 900px) {
    .layout__sub-header:after {
      background-image: var(--bg-mo, url('/images/sub_mo.png'));
    }
  }
</style>
